import { render } from "./App.vue?vue&type=template&id=c3b89250"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c3b89250&lang=scss"

import exportComponent from "D:\\工作\\打工\\2021-AutoInspectionSystem\\trunk\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__